/*
 * @author: Kody
 * @description: 获取班级学员列表
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';
import { IOutput } from './models/output';

interface IInput {
    class_id: string;
    page: number;
    size: number;
}

export const getStudentList = (param: IInput): Promise<IListResponse<IOutput>> => {
    return fetchData(Api.CLASS_JOIN_STUDENT, param).then((res: IListResponse<IOutput>) => {
        return res;
    });
};
